module.exports = {
      id: "magazines-usage",
      viewBox: "0 0 25.36 20.288",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#magazines",
      toString: function () {
        return this.url;
      }
    }